import styles from './styles.module.scss';
import Icon from 'components/icon';
import Tooltip from 'components/tooltip';
import IconType from 'models/ActionBar/Icon';
import { useMenu } from 'context/MenuContext';
import Locale from 'components/locale';
import Dropdown from './dropdown';
import Notifications from 'components/notifications';
import Inline from 'components/inline';
import { NotificationContextProvider } from 'context/NotificationContext';

function ActionBar() : JSX.Element {
  const { customConfig } = useMenu();

  const getTooltip = (icon : IconType, index : number) : JSX.Element => {
    const element = <a href={icon.url} key={index}><Icon iconName={icon.iconName}/></a>;

    if(!icon.tooltip)
      return element;

    return (
      <Tooltip key={index} text={icon.tooltip}>{element}</Tooltip>
    );
  };

  return (
    <div id={styles['biobar-action-bar']}>
      { customConfig.icons && customConfig.icons.map((x, i) => getTooltip(x, i)) }
      { customConfig.dropdown && <Dropdown />}
      { customConfig.includeNotifications &&
        <NotificationContextProvider>
          <Notifications />
        </NotificationContextProvider>
      }
      { customConfig.inlineManualUrl && <Inline />}
      <Locale />
    </div>
  );
}

export default ActionBar;